import {
    fetchDecorationTypes,
    fetchDecorations
} from "../data/apiClient";

import {
    getDecorationTypeMappedList
} from "./decorationTypeMapper";

export const decorationRepository = {
    getDecorationTypes: async () => {
        const response = await fetchDecorationTypes();
        const typesDtoList = response.data;
        return getDecorationTypeMappedList(typesDtoList);
    },

    getDecorations: async (typeId, page) => {
        const response = await fetchDecorations(typeId, page);
        const result = response.data;
        return result
    }

};